export const SET_STATE = 'checkoutPage/vehicleRentalFilters/SET_STATE';
export const SET_FUEL_TYPE_OPTIONS = 'checkoutPage/vehicleRentalFilters/SET_FUEL_TYPE_OPTIONS';
export const SET_FUEL_TYPE_VALUE = 'checkoutPage/vehicleRentalFilters/SET_FUEL_TYPE_VALUE';
export const SET_TRANSMISSION_TYPE_OPTIONS = 'checkoutPage/vehicleRentalFilters/SET_TRANSMISSION_TYPE_OPTIONS';
export const SET_TRANSMISSION_TYPE_VALUE = 'checkoutPage/vehicleRentalFilters/SET_TRANSMISSION_TYPE_VALUE';
export const SET_PASSENGER_CAPACITY_OPTIONS = 'checkoutPage/vehicleRentalFilters/SET_PASSENGER_CAPACITY_OPTIONS';
export const SET_PASSENGER_CAPACITY_VALUE = 'checkoutPage/vehicleRentalFilters/SET_PASSENGER_CAPACITY_VALUE';
export const RESET_STATE = 'checkoutPage/vehicleRentalFilters/RESET_STATE';
